import { apiClient } from '@/api/api'
import type {
  AiraActionBody,
  AiraContextualResponse,
  AiraContextualSurface,
  AiraSendMessageBody,
  AiraSendMessageResponse,
  AiraThreadPage,
  AiraVocab,
} from './types'

/** The backend's model timeout (`AIRA_CHAT_TIMEOUT`, 30 s) plus its one fast retry. */
export const AIRA_REQUEST_TIMEOUT_MS = 40_000

export const AIRA_THREAD_PAGE_SIZE = 30

/** One turn with the stylist; a model failure is `200 + status: degraded`, never a 5xx. */
export const postAiraMessage = async (body: AiraSendMessageBody) =>
  apiClient.post<AiraSendMessageResponse>('/aira/message', body, {
    timeout: AIRA_REQUEST_TIMEOUT_MS,
  })

/** Shuffle / Replace: the generator answers in 1–5 s; a failure is `200 + status: degraded`. 400 `wardrobe_unsupported`. */
export const postAiraAction = async (body: AiraActionBody) =>
  apiClient.post<AiraSendMessageResponse>('/aira/actions', body, {
    timeout: AIRA_REQUEST_TIMEOUT_MS,
  })

/** The one history of both surfaces, newest first; `cursor` = the previous page's `nextCursor`. */
export const getAiraThread = async (params: { cursor?: string | null; limit?: number } = {}) =>
  apiClient.get<AiraThreadPage>('/aira/thread', {
    params: {
      ...(params.cursor ? { cursor: params.cursor } : {}),
      limit: params.limit ?? AIRA_THREAD_PAGE_SIZE,
    },
  })

/** Public, `Cache-Control: max-age=3600` — the chips come from here only. */
export const getAiraVocab = async () => apiClient.get<AiraVocab>('/aira/vocab')

/**
 * The contextual assistant's cards for a page (contract §7). Guests may call it (K1 / K9 are
 * for them); a signed-in caller gets the wardrobe-aware ones (K7).
 */
export const getAiraContextualTips = async (params: {
  surface: AiraContextualSurface
  productId?: number | null
  variantId?: number | null
  capsuleId?: number | null
  outfitId?: number | null
  query?: string | null
}) =>
  apiClient.get<AiraContextualResponse>('/aira/contextual', {
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => value != null)),
  })
